import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

export const triggerAssignmentsLoadingOnFilterChange = store.effects.create(
  (feature: Feature) =>
    feature.selectors.assignmentsFilters.asObservable.pipe(
      rxjs.switchMap(filters =>
        rxjs.from([
          feature.actions.getAssignments
            .from('triggerLoadingOnContextChange (effect)')
            .create({ filters }),
        ]),
      ),
    ),
)
